import { render } from "./CrDataProtection.vue?vue&type=template&id=4985e4a2&scoped=true"
import script from "./CrDataProtection.vue?vue&type=script&lang=js"
export * from "./CrDataProtection.vue?vue&type=script&lang=js"

import "./CrDataProtection.vue?vue&type=style&index=0&id=4985e4a2&scoped=true&lang=css"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985e4a2"]])

export default __exports__